import axios from 'axios'
import { DateTime } from 'luxon'
import i18n from '../lang'
import themeSettings from '@/theme-settings.json'

/**
 * Concrete implementation of easyjet flight tracker apis
 *
 * should be considered private, use Api to access
 **/
export default {

  /**
   * Get flights matching search criteria supplied
   * @param {number} date - epoch in millis for date of flight
   * @param {string} flightReference - The flight reference with or without prefixed carrier code
   * @returns {Promise<FlightResult[]>} - A promise containing array of FlightResult
   */
  getFlight (date, flightReference) {
    let dateTime = DateTime.fromMillis(date)
    let dateString = dateTime.toFormat('yyyy-MM-dd')
    const airlineFilters = Array.isArray(themeSettings.airline)
      ? themeSettings.airline
      : (themeSettings.airline ? [themeSettings.airline] : [])
    // todo make relative path if we want to test locally served functions? It works locally but not sure
    // we want to use local when dev'd as you need firebase emulator running
    return axios.get(themeSettings.endpoints.findFlight, {
      params: {
        date: dateString,
        fn: flightReference,
        airline: airlineFilters.join(','),
        lang: i18n.lang
      },
      headers: {
        'Accept': 'application/json;version=3',
        'Application-Author': 'first-flight',
        'Application-Name': 'first-flight-claims',
        'Application-Platform': 'web',
        'Application-Version': '2.0'
      }
    }).then((results) => {
      if (results && results.data && results.data.flights) {
        return results.data.flights.map(flight => {
          return new FlightResult(
            FlightResult.fromEasyJetFlight(flight)
          )
        })
      } else {
        return []
      }
    })
  }
}

/**
 * Internal model class to hold find flight results
 */
export class FlightResult {
  /**
   * @param {Object} data
   * todo document add add keys we'd like to translate from external api to local momdel as needed
   */
  constructor (data) {
    this._flightReference = data.flightReference
    this._arrival = data.arrival
    this._departure = data.departure
  }

  static fromEasyJetFlight (flight) {
    return new FlightResult({
      flightReference: flight.fn,
      arrival: {
        airport: {
          name: flight.airports.aaa.name,
          iata: flight.airports.aaa.iata
        },
        date: flight.dates.eta
      },
      departure: {
        airport: {
          name: flight.airports.ada.name,
          iata: flight.airports.ada.iata
        },
        date: flight.dates.etd
      }
    })
  }

  get flightReference () { return this._flightReference }
  set flightReference (flightReference) { this._flightReference = flightReference }

  get arrival () { return this._arrival }
  set arrival (arrival) { this._arrival = arrival }

  get departure () { return this._departure }
  set departure (departure) { this._departure = departure }
}
